import type { JsonValue } from '../types/settings';

export function loadStoredJSON<T extends JsonValue>(key: string, fallback: T): T {
  const raw = localStorage.getItem(key);
  if (!raw) return fallback;

  try {
    return JSON.parse(raw) as T;
  } catch (err) {
    console.error(`loadStoredJSON(${key}):`, err);
    return fallback;
  }
}

export function storeJSON(key: string, value: JsonValue): void {
  localStorage.setItem(key, JSON.stringify(value));
}
